export type SiteResponse = {
	id: number;
	name: string;
};

export enum DeviceStatus {
	DEPLOYED = 'DEPLOYED',
	PENDING = 'PENDING',
	UNKNOWN = 'UNKNOWN',
	REFUSED = 'REFUSED',
	RESEARCH = 'RESEARCH'
}

export const deviceStatusOptions: { value: DeviceStatus; label: string }[] = [
	{ value: DeviceStatus.PENDING, label: 'Pending' },
	{ value: DeviceStatus.DEPLOYED, label: 'Deployed' },
	{ value: DeviceStatus.UNKNOWN, label: 'Unknown' },
	{ value: DeviceStatus.REFUSED, label: 'Refused' },
	{ value: DeviceStatus.RESEARCH, label: 'Research' }
];

export type LandownerRequest = {
	firstName: string;
	lastName: string;
	streetAddress: string;
	city: string;
	state: string;
	zip: string;
	mailingAddress: string;
	email: string;
	phone: string;
	mobile: string;
	siteId: number;
	initialPayment: number;
	recurringPayment: number;
	initialDeploymentDate: string;
	status: DeviceStatus;
	latitude: number;
	longitude: number;
};

export type LandownerResponse = {
	id: number;
} & LandownerRequest;
